module.exports = __webpack_public_path__ + "7471184612ad8fb9f84611bcaa248e6c.MP3";